import React, { Component } from 'react'
import * as actions from "./actions";
import * as utils from "../utils";
import DeleteItemLink from "../common/components/delete-item-link";
import RsvpToPerformActionLink from "../common/components/rsvp-to-perform-action-link";
import RsvpToPerformActionButton from "../common/components/rsvp-to-perform-action-button";

import { connect } from 'react-redux';

function WhatToBring(props) {
  const whattobring = props.state.whattobring;
  if (!utils.isHost() && !whattobring.creator_id) {
    return <WhatToBringEmptyNotice />
  }
  let viewComponent = <WhatToBringSelect whattobring={ whattobring } />;
  if (whattobring.editing) {
    viewComponent = <WhatToBringCreateUpdate whattobring={ whattobring } />;
  }
  return (
    <div>
      { !utils.isMobile() && !window.is_premium &&
        <DesktopAd />
      }
      { viewComponent }
    </div>
  );
};

function WhatToBringEmptyNotice(props) {
  return (
    <div className="whattobring-notice">
      The host has removed the list from this event
    </div>
  );
}

const WhatToBringCreateUpdate = React.createClass({
  render: function () {
    const { items, creator_id, allow_other_items } = this.props.whattobring;
    const canAdd = items.length <= 50;
    const creating = !creator_id;
    const allow_other = allow_other_items ? true : false
    const buttonText = creating ? "Create" : "Update";
    const disable_options = canAdd ? false : "disabled";
    return (
      <div className="what-to-bring edit simple-shadowbox">
        <h3>Ask Guests to Bring Something</h3>
        <p className="label">List desired items and quantities below. As quantities are met, items will disappear from the list.</p>
        <form onSubmit={ this.handleCreateUpdate }>
          <table>
            <thead>
              <tr>
                <th>Items</th>
                <th>Total Needed</th>
              </tr>
            </thead>
            <WhatToBringCreateTable items={ items } />
          </table>
          <div className="footer">
            { canAdd &&
              <div>
                <a
                  className="add-another-item"
                  href="#"
                  onClick={ this.handleAddItem }
                >
                Add another item
                </a>
                <fieldset id="allow_items_fieldset" style={ { 'marginTop': '15px', 'textAlign': 'left'} }>
                  <input
                    disabled={ disable_options }
                    type="checkbox"
                    id="allow_other_items"
                    checked={ allow_other }
                    onChange={ this.handleCheckboxChange }
                  />
                  <label htmlFor="allow_other_items">
                    <span></span>
                    Other - Check to allow guests to add custom items to this list.
                  </label>
                </fieldset>
              </div>
            }
            <button className="button-primary-inverse">{buttonText}</button>
            { !creating &&
              <div>
                <ToggleEditLink linkText="Cancel" />
              </div>
            }
          </div>
        </form>
      </div>
    );
  },
  handleAddItem: function(e) {
    e.preventDefault();
    actions.addItem();
  },
  handleCreateUpdate: function (e) {
    e.preventDefault();
    const { items, creator_id, allow_other_items } = this.props.whattobring;
    let itemList = [];
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      if (item.name && item.quantity > 0) {
        itemList.push({
          name: item.name,
          quantity: parseInt(item.quantity)
        });
        if (item.id) {
          // Add item id if we have one (updating)
          itemList[i].id = item.id;
        }
      }
    }
    if (itemList.length === 0) {
      return false;
    }
    const itemListStr = JSON.stringify(itemList);
    const data = {
      items: itemListStr,
      allow_other_items: allow_other_items
    };
    if (creator_id) {
      actions.updateWhatToBring(data);
    } else {
      actions.createWhatToBring(data);
      window.dataLayer.push({'event': 'createlist'});
    }
  },
  handleCheckboxChange: function(e) {
    actions.toggleAllowOtherItems();
  }
});

const WhatToBringCreateTable = React.createClass({
  render: function() {
    const items = this.props.items;
    const itemNodes = items.map((item, i) => {
      return <WhatToBringRow
          item={ item }
          key={ i }
          index={ i }
          handleItemChange={ this.handleItemChange.bind(this, i) }
          handleQtyChange={ this.handleQtyChange.bind(this, i) }
          handleRemoveClick={ this.handleRemoveClick.bind(this, i) }
          handleQtyKeyDown={ this.handleQtyChange.bind(this, i) }
      />
    });
    return (
      <tbody>
        {itemNodes}
      </tbody>
    );
  },
  handleItemChange: function(index, e) {
    actions.updateItemName(index, e.target.value);
  },
  handleQtyChange: function(index, e) {
    actions.updateItemQty(index, e.target.value.substr(0, 3));
  },
  handleRemoveClick: function(index, e) {
    e.preventDefault();
    actions.removeItem(index);
  },
  handleQtyKeyDown: function(index, e) {
    const itemsLen = this.props.items.length;
    if (e.keyCode === 9 && !e.shiftKey && index + 1 === itemsLen) {
      e.preventDefault();
      actions.addItem();
    }
  }
});

function WhatToBringRow (props) {
  const { placeholder, autofocus } = props.item;
  const required = props.index === 0 || props.item.name.length || props.item.quantity.length;
  return (
    <tr>
      <td>
        <input type="text"
          value={ props.item.name }
          maxLength="140"
          placeholder={ placeholder }
          autoFocus={ autofocus }
          required={ required }
          onChange={ props.handleItemChange }
        />
      </td>
      <td>
        <input
          type="number"
          value={ props.item.quantity }
          min="1"
          max="999"
          placeholder="Qty"
          required={ required }
          onChange={ props.handleQtyChange }
          onKeyDown={ props.handleQtyKeyDown }
        />
        <a onClick={ props.handleRemoveClick } tabIndex="-1">
          <i className="icon-cancel"></i>
        </a>
      </td>
    </tr>
  );
}

function WTBHeader(props) {
  const { creator_id } = props.wtb;
  const canDeleteAndEdit = utils.canDeleteEventItem(creator_id);
  return (
    <div style={ { 'position': 'relative' } }>
      <h3>
        Sign Up to Bring Something&nbsp;
        { canDeleteAndEdit &&
          <small>(<ToggleEditLink />)</small>
        }
      </h3>
      { canDeleteAndEdit &&
        <DeleteWhatToBringLink />
      }
    </div>
  );
}

const WhatToBringSelect = React.createClass({
  getInitialState: function() {
    return {
      selected: "",
      quantity: "",
      maxQty: 0,
      name: "",
      placeholder: "Type what you will bring here."
    }
  },
  render: function() {
    const { selected, quantity } = this.state;
    const otherSelected = selected === 'other';
    const { items, my_selections, allow_other_items } = this.props.whattobring;
    const hasRsvpd = utils.hasRsvpd();
    let qtyItemsRemaining = 0;
    const itemNodes = items.map((option, i) => {
      const { id, name } = option;
      const key = `whattobring-option-${ i }`;
      const remaining = option.remaining;
      if (remaining > 0) {
        qtyItemsRemaining++;
        return (
          <option value={ id } key={ key }>{ name }</option>
        )
      }
    });
    const qtyNodes = [];
    const itemIndex = items.map(function(item) {
      return item.id;
    }).indexOf(selected);
    const itemInMySelectionsIndex = my_selections.map(function(item) {
      return item.id;
    }).indexOf(selected);
    const remaining = items[itemIndex] ? items[itemIndex].remaining : 0;
    for (let i = 0; i < remaining; i++) {
      const alreadyBringingItem = itemInMySelectionsIndex > -1;
      const moreWord = alreadyBringingItem ? "more" : "";
      const num = i + 1;
      let val = num;
      if (alreadyBringingItem) {
        val += my_selections[itemInMySelectionsIndex].quantity;
      }
      const key = `whattobring-qty-${i}`;
      qtyNodes.push(<option value={val} key={key}>{num} {moreWord}</option>);
    }
    const listComplete = qtyItemsRemaining == 0;
    return (
      <div>
        { !hasRsvpd &&
          <RsvpToPerformActionLink action="contribute" />
        }
        <div className="what-to-bring simple-shadowbox select">
          <WTBHeader wtb={ this.props.whattobring } />
          <WhatToBringGuestItemTable items={items}/>
          <UserSelections mySelections={my_selections} />
          { listComplete &&
            <div className="list-complete">Looks like everything is taken care of!</div>
          }
          { hasRsvpd && (!listComplete || allow_other_items ) &&
            <form onSubmit={ this.handleSubmit }>
              { otherSelected &&
                <table className="other">
                  <tbody>
                     <WhatToBringRow
                      item={ this.state }
                      key={ 'other' }
                      index={ 'other' }
                      handleItemChange={ this.handleItemChange }
                      handleQtyChange={ this.handleQuantityChange }
                      handleRemoveClick={ this.handleCancelClick }
                      handleQtyKeyDown={ this.handleQuantityChange }
                    />
                  </tbody>
                </table>
              }
              { !otherSelected &&
                <div>
                  <select onChange={ this.handleSelectChange } value={selected} required>
                    <option value="">Select an Item to Bring</option>
                    { itemNodes }
                    { allow_other_items &&
                      <option value="other" key="whattobring-option-other">Other</option>
                    }
                  </select>
                  <select onChange={this.handleQuantityChange} value={quantity} required>
                    <option value="">Qty</option>
                    { qtyNodes }
                  </select>
                </div>
              }
              <button className="button-primary-inverse">Add to List</button>
            </form>
          }
          {!hasRsvpd &&
            <div style={{textAlign: 'center'}}>
              <RsvpToPerformActionButton action="contribute" />
            </div>
          }
        </div>
      </div>
    );
  },
  handleSelectChange: function(e) {
    const itemId = e.target.value;
    const items = this.props.whattobring.items;
    const itemIndex = items.map(function(item) {
      return item.id;
    }).indexOf(itemId);
    const remaining = items[itemIndex] ? items[itemIndex].remaining : 0;
    this.setState({
      selected: itemId,
      maxQty: remaining
    });
  },
  handleItemChange: function(e) {
    this.setState({
      name: e.target.value
    })
  },
  handleCancelClick: function () {
    this.setState({
      selected: "",
      quantity: "",
      name: "",
      maxQty: 0
    })
  },
  handleQuantityChange: function(e) {
    const qty = e.target.value;
    this.setState({quantity: qty});
  },
  handleSubmit: function(e) {
    e.preventDefault();
    const { selected, quantity, name } = this.state;
    if (!selected || quantity < 1) {
      return false;
    }
    actions.selectItem(selected, name, quantity);
    this.setState({
      selected: "",
      quantity: "",
      maxQty: 0,
      name: ""
    });
    window.dataLayer.push({'event': 'bringitem'});
  }
});

const UserSelections = React.createClass({
  render: function(e) {
    const { mySelections } = this.props;
    const selectionNodes = mySelections.map((selection, i) => {
      const { id, quantity, name } = selection;
      const key = `whattobring-selection-${i}`;
      return (
        <p key={key}>
          You're bringing {quantity} {name}&nbsp;
          <small>
            <a href="#" onClick={this.handleRemoveSelectionClick.bind(this, id)}>
              Remove
            </a>
          </small>
        </p>
      )
    });
    return (
      <div className="youre-bringing">
        {selectionNodes}
      </div>
    );
  },
  handleRemoveSelectionClick: function(id, e) {
    e.preventDefault();
    actions.removeSelection(id);
  }
});

const WhatToBringGuestItemTable = React.createClass({
  render: function () {
    let itemNodes = null;
    if (this.props.items) {
      itemNodes = this.props.items.map((item, i) => {
        if (item.id) {
          const key = `whattobring-view-item-${i}`;
          return (
            <WhatToBringGuestItemRow item={item} i={i} key={key} />
          )
        }
      });
    }
    return (
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Who</th>
            <th>Still Needed</th>
          </tr>
        </thead>
        <tbody>
          {itemNodes}
        </tbody>
      </table>
    );
  }
});

const WhatToBringGuestItemRow = React.createClass({
  render: function () {
    const { name, quantity, remaining, selections, id } = this.props.item;
    const selectionNodes = selections.map((selection, i) => {
      const { quantity, user } = selection;
      const { first_name, last_name } = user;
      const key = `whattobring-who-${i}`;
      return (
        <div key={key}>
          {first_name} {last_name} ({quantity})
        </div>
      );
    });
    const who = selectionNodes.length ? selectionNodes : "No one";
    return (
      <tr>
        <td>{name}</td>
        <td>{who}</td>
        <td>{remaining > 0 ? remaining : 0}</td>
      </tr>
    );
  }
});

const ToggleEditLink = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    return (
      <a href="#" className="toggle-edit" onClick={this.handleEditClick}>
        {this.props.linkText || "Edit"}
      </a>
    );
  },
  handleEditClick: function(e) {
    e.preventDefault();
    actions.toggleEdit();
  }
})

const DeleteWhatToBringLink = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    return (
      <DeleteItemLink
        onConfirmClick={this.handleDeleteClick}
        heading="Remove What to Bring?"
        body="Are you sure you would like to remove this list?"
      />
    );
  },
  handleDeleteClick: function () {
    actions.deleteWhatToBring();
  }
})

const DesktopAd = React.createClass({
  shouldComponentUpdate: function() {
    // Don't re-render on state changes
    return false;
  },
  componentDidMount: function() {
    if (!window.sponsoredWtbAd) {
      window.setTimeout(function() {
        googletag.cmd.push(function() {
          window.sponsoredWtbAd = googletag.defineSlot(
            `${window.dfp_desktop_id}/${desktop_slot3()}`,
            [[420, 101]],
            "div-gpt-wtb-sponsored-ad"
          )
          .addService(googletag.pubads());
          googletag.display('div-gpt-wtb-sponsored-ad');
        });
      }, 2000);
    }
  },
  render: function() {
    return (
      <div id="div-gpt-wtb-sponsored-ad" className="gpt-ad"></div>
    );
  }
})

function mapStateToProps(state) {
  return {
    state: {
      whattobring: state.whattobring
    }
  }
};

const connectedWhatToBring = connect(mapStateToProps)(WhatToBring);

export default connectedWhatToBring;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/what-to-bring/components.es6